import React from 'react';
import { Link } from 'react-router-dom';
//import blog3 from '../../images/blog-details/comments-author/img-1.jpg';
//import blog4 from '../../images/blog-details/comments-author/img-2.jpg';
//import blog5 from '../../images/blog-details/comments-author/img-3.jpg';
//import blog6 from '../../images/blog-details/author.jpg';
import blog7 from '../../images/blog-details/image-4.jpg';
import blog8 from '../../images/blog-details/image-5.jpg';
import blogs from '../../api/blogs';
import { useParams } from 'react-router-dom';

const BlogSingle = props => {
	const { slug } = useParams();

	const NewsDetails = blogs.find(item => item.slug === slug);

	const submitHandler = e => {
		e.preventDefault();
	};

	const ClickHandler = () => {
		window.scrollTo(10, 0);
	};

	return (
		<section className='py-[120px] md:py-[90px] sm:py-[80px]'>
			<div className='wraper'>
				<div className={`${props.gClass} grid gap-3`}>
					<div className={`col-span-8 md:col-span-12 ${props.blRight}`}>
						<div className=''>
							<div className='mb-[70px]'>
								<h3 className='text-[34px] md:text-[25px] sm:text-[22px] text-[#282e3f] font-normal font-heading-font leading-[40px] pt-7 transition-all mb-[20px] group'>
									{NewsDetails.title}
								</h3>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									{NewsDetails.description}
								</p>
								<h4 className='text-[#282e3f] text-[26px] md:text-[21px] sm:text-[18px] mb-[20px]'>
									Assurance automobile
								</h4>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									Le télétravail a nécessairement entraîné une diminution voire un arrêt total de vos
									trajets en voiture. Cependant, vous continuez à payer votre assurance auto alors que
									vous ne l'utilisez plus.
								</p>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>Que faire ?</p>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									Vérifiez auprès de votre assureur s'il n'est pas envisageable de suspendre
									temporairement le contrat d'assurance. De cette façon, vous ne devrez plus payer
									votre prime d'assurance. Cependant, vous ne devez pas perdre de vue que votre
									véhicule ne sera plus assuré. Or, un véhicule doit obligatoirement être assuré
									lorsqu'il se trouve sur la voie publique. Dès lors, vous ne pourrez envisager une
									suspension temporaire de votre contrat d'assurance que si vous pouvez laisser votre
									véhicule sur votre propriété privée (garage, terrain, etc...).
								</p>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									A ce sujet, n'hésitez pas à vérifier les conditions particulières et générales de
									votre assurance Habitation / Incendie. En effet, certaines polices d'assurance
									peuvent par exemple prévoir l'indemnisation de votre véhicule situé à l'intérieur de
									votre garage en cas d'incendie de votre habitation.
								</p>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'></p>
								<h4 className='text-[#282e3f] text-[26px] md:text-[21px] sm:text-[18px] mb-[20px]'>
									Accident du travail
								</h4>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									En raison de la crise sanitaire, la plupart des citoyens travaillent depuis leur
									domicile et non plus depuis le bureau mis à leur disposition par leur employeur. Ce
									changement n'empêche évidemment pas d'être victime d'un accident du travail.
								</p>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									On entend par accident du travail, l'accident survenu dans le cours et par le fait
									de l'exercice des fonctions et qui produit une lésion. Imaginez que vous soyez parti
									vous désaltérer dans votre cuisine et que vous receviez un appel via Skype de la
									part d'un collègue. Vous vous dépêchez à vous rendre à votre ordinateur et vous
									chutez lourdement sur le sol entraînant une fracture de votre poignet.
								</p>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									Vous pourriez penser qu'il s'agit d'un accident de la vie privée de sorte que vous
									devriez supporter tous les frais médicaux, etc… Il peut difficilement être contesté
									qu'il s'agit d'un accident survenu dans le cours et par le fait de l'exercice de vos
									fonctions de sorte que l'assureur-loi de votre employeur prendra notamment en charge
									tous les frais médicaux.
								</p>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									Dans ce cas, il convient de remplir immédiatement une déclaration d'accident du
									travail et de la transmettre à votre employeur.
								</p>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									Le fait qu'un accident du travail se déroule au sein de votre domicile ne change dès
									lors rien pour vous !
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default BlogSingle;
